import React from 'react';
interface AppSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
}
export function AppSwitch({
  checked,
  onChange,
  label,
  disabled = false
}: AppSwitchProps) {
  return <label className="inline-flex items-center cursor-pointer group" data-id="element-93">
      <button type="button" role="switch" aria-checked={checked} disabled={disabled} onClick={() => !disabled && onChange(!checked)} className={`
          relative inline-flex h-6 w-11 items-center rounded-full transition-all duration-180
          focus:outline-none focus:ring-3 focus:ring-blue-100
          ${checked ? 'bg-blue-600' : 'bg-gray-300'}
          ${disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'}
        `} data-id="element-94">
        <span className={`
            inline-block h-4 w-4 transform rounded-full bg-white shadow-sm transition-transform duration-180
            ${checked ? 'translate-x-6' : 'translate-x-1'}
          `} data-id="element-95" />
      </button>
      {label && <span className={`ml-3 text-sm font-medium ${disabled ? 'text-gray-400' : 'text-gray-700'}`} data-id="element-96">
          {label}
        </span>}
    </label>;
}